import React, { useState } from "react";
import { Form, Spinner, Button, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { AmplitudePageName, track } from "utils/amplitude";
import requestDemo from "services/requestDemo";
import getClasses from "utils/getClasses";
import styles from "./SubscribeToNewsletter.module.scss";

const SubscribeToNewsletter = ({
  page,
  setError,
  AMPLITUDE_PAGE_NAME,
}: {
  page?: string;
  setError: React.Dispatch<React.SetStateAction<Error | undefined>>;
  AMPLITUDE_PAGE_NAME: AmplitudePageName;
}) => {
  const { isPhonePortrait } = usePhonePortraitContext();

  const [validated, setValidated] = useState<boolean>(false);
  const [busy, setBusy] = useState<boolean>(false);

  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    setError(undefined);

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    setBusy(true);

    try {
      await requestDemo(name, "", email);
      window.location.href = `https://calendly.com/hey-orchid/orchid-walkthrough?name=${name}&email=${email}`;
    } catch (error: any) {
      setError(error.toString());
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className={getClasses(
        page === "press" && styles["dark-mode"],
        !isPhonePortrait ? styles["newsletter"] : styles["newsletter--phone"],
      )}
    >
      <div
        className={
          !isPhonePortrait ? styles["container"] : styles["container--phone"]
        }
      >
        <div
          className={
            !isPhonePortrait ? styles["sub-title"] : styles["sub-title--phone"]
          }
        >
          Subscribe to Our Newsletter
        </div>
        <div className={"mb-4"}>
          Get the latest updates & strategies for mental healthcare
          professionals.
          <br />
          100% free. Unsubscribe anytime. See our{" "}
          <Link to={"/privacy-policy"}>Privacy Policy</Link>.
        </div>
        <Form
          className={getClasses(
            styles["form-row"],
            isPhonePortrait && styles["form-row--phone"],
          )}
          onSubmit={handleSubmit}
          validated={validated}
          noValidate
        >
          <Form.Group as={Col} md={5} xs={12}>
            <Form.Control
              required
              type="text"
              placeholder="Your email address"
              name="email"
              aria-describedby="email"
              value={email || ""}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
          </Form.Group>
          <Form.Group as={Col} md={5} xs={12}>
            <Form.Control
              required
              type="text"
              placeholder="Your name"
              name="name"
              aria-describedby="name"
              value={name || ""}
              onChange={(e) => setName(e.currentTarget.value)}
            />
          </Form.Group>
          <Button
            disabled={busy}
            type="submit"
            onClick={() => {
              !isPhonePortrait
                ? track(AMPLITUDE_PAGE_NAME, "submit-button", "click")
                : track(AMPLITUDE_PAGE_NAME, "mobile-submit-button", "click");
            }}
          >
            Submit{" "}
            {busy && (
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default SubscribeToNewsletter;
